export default __webpack_public_path__ + "static/media/credz.ebe88a2d.png";